module.exports = __webpack_public_path__ + "static/media/Nutshell.928b5c81.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/about/Nutshell.png
// module id = 592
// module chunks = 8